module.exports = __webpack_public_path__ + "img/2.b42bbc23.jpg";